
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/artificial-intelligence-development-services",
      function () {
        return require("private-next-pages/artificial-intelligence-development-services.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/artificial-intelligence-development-services"])
      });
    }
  